import { LayoutSection } from "../../shared/LayoutSection";
import { VisibilitySection } from "../../shared/VisibilitySection";
import { ShopBlockEditor } from "@tellescope/shop";
import type { BlockTypeEditorProps } from "../../types";
import type { ShopBlock } from "../../../../../../shared/schema";

type ShopBlockEditorAdapterProps = BlockTypeEditorProps<ShopBlock>;

/**
 * Bridges ShopBlockEditor's own props (emptyMessage/products/onSave — it has an explicit Save
 * step gated on Stripe-to-Product reverse-lookup verification, unlike every other block editor's
 * live/reactive updateProps) to the standard BlockTypeEditorProps every other block editor uses.
 */
export const ShopBlockEditorAdapter = ({
  block,
  updateProps,
  updateLayout,
  updateVisibility,
  layoutOpen,
  setLayoutOpen,
  visibilityOpen,
  setVisibilityOpen,
}: ShopBlockEditorAdapterProps) => (
  <div className="space-y-4">
    <ShopBlockEditor
      title={block.props.title}
      subtitle={block.props.subtitle}
      emptyMessage={block.props.emptyMessage}
      confirmationMessage={block.props.confirmationMessage}
      products={block.props.products}
      stripeKey={block.props.stripeKey}
      onSave={(props) => updateProps(props)}
    />

    <LayoutSection layout={block.layout} onChange={updateLayout} open={layoutOpen} onOpenChange={setLayoutOpen} />
    <VisibilitySection
      visibility={block.visibility}
      onChange={updateVisibility}
      open={visibilityOpen}
      onOpenChange={setVisibilityOpen}
    />
  </div>
);
